import { render, staticRenderFns } from "./Fujian.vue?vue&type=template&id=32cdba37&scoped=true&"
import script from "./Fujian.vue?vue&type=script&lang=js&"
export * from "./Fujian.vue?vue&type=script&lang=js&"
import style0 from "./Fujian.vue?vue&type=style&index=0&id=32cdba37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cdba37",
  null
  
)

export default component.exports